export default __webpack_public_path__ + "static/Tek_Dinosaur_Gate-ed810eb87b0dcc1d97dda1c201f43c0c.png";